import './css/App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from './Home';
import About from './About';
import Contact from './Contact';
import Error from './Error';
import PressKit from './PressKit';
import FAQ from './FAQ';
import Blog from './Blog';

function App() {
  return <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/presskit" element={<PressKit />} />
        <Route path="/faq" element={<FAQ />} />

        

        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>  
}

export default App;
